import { call, put, select, takeEvery } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getEntityColonyTypeCombo from '../../services/dossier/get/getEntityColonyTypeCombo'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchEntityColonyTypeCombo ({ townId, resolve }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    let combo = []
    if (townId !== -1) {
      combo = yield call(getEntityColonyTypeCombo, auth.token, townId)
    }
    if (resolve) {
      resolve(combo)
    } else {
      yield put(fetchCombosSuccess({ entityColonyTypeCombo: combo }))
    }
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchEntityColonyTypeCombo () {
  yield takeEvery(combosActionTypes.FETCH_ENTITY_COLONY_COMBO, fetchEntityColonyTypeCombo)
}
